import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { useApi } from "shared/services/api/useApi";

const SessionContext = React.createContext();

export const SessionProvider = (props) => {
    const [session, setSession] = useState(null);
    const { getDataAsync } = useApi();

    useEffect(() => {
        const loadSession = async () => {
            if (session === null) {
                const payload = await getDataAsync("session");
                const data = payload ? await payload.json() : null;

                // this is for google analytics
                if (data?.legacyId) {
                    globalThis.dataLayer = globalThis.dataLayer || [];
                    globalThis.dataLayer.push({
                        user_id: data?.legacyId,
                        email: data?.email,
                        type: data?.type,
                        currentTitle: data?.currentTitle,
                        currentDepartment: data?.currentDepartment,
                        fullName: data?.fullName,
                        currentOffice: data?.currentOffice,
                        currentPayOffice: data?.currentPayOffice,
                        agencyId: data?.agencyId,
                        startDate: data?.startDate,
                        timesheetRequired: data?.timesheetRequired,
                        contractor: data?.contractor,
                        freelancer: data?.freelancer,

                    });
                }

                setSession(data);
            }
        };

        loadSession();
    }, [getDataAsync, session]);

    return session === null ? (
        <div> Loading ...</div>
    ) : (
        <SessionContext.Provider value={session}>
            {props.children}
        </SessionContext.Provider>
    );
};

SessionProvider.propTypes = {
    children: PropTypes.node,
};

export default SessionContext;
